import React, { useState } from 'react';
import {RouterProvider, useNavigate} from 'react-router-dom'
import router from '../../router'
import styles from "./app.module.scss";
import {GitlabOutlined, TwitterOutlined, SearchOutlined, RightOutlined} from '@ant-design/icons';
import HeadMenu from '../../components/menus'
import { commonMenus } from "../../utils/menus";
import {notification} from "antd";
const version = '2.8.4'
let isTips = localStorage.getItem('version') === version ? true : false
// 动态设置搜索列表的高度
const setSearchStyle = function () {
    let { offsetHeight } = document.querySelector('#searchList')
    const searchBox = document.querySelector('#searchBox')
    if (offsetHeight > 300) {
        offsetHeight = 300
    }
    searchBox.style.height = offsetHeight + 'px'
}

const Tip = ({version}) => {
    return (
        <div>
            <p>各位莓友开发者们，莓创图表更新啦，此次更新版本号：<span style={{'color': 'red', fontWeight: 600}}>{version}</span>，快来下载吧</p>
            <h5>更新的内容（详情更新内容可查看更新日志）：</h5>
            <ul>
                <li>
                    1、修复轴坐标最后一个元素无法显示问题。
                </li>
                <li>
                    2、新增柱状图新增自定义设置每根柱子的label颜色
                </li>
                <li>
                    3、优化饼图的指标连接线重叠的算法
                </li>
            </ul>
        </div>
        // <div>
        //     <p>大家好，图表最近迎来新的版本内测时间，内测时间为： <span style={{'color': 'red', fontWeight: 600}}>2024-09-23至2024-09-30</span>，希望各位有时间的可以更新内测版本，验证一下是否会影响当前使用的功能，避免后续升级出现错误异常。有新的提议都可以提出来。</p>
        //     <h5>更新的步骤</h5>
        //     <ul>
        //         <li>
        //             1、删除历史的版本记录，包含oh_modules整个目录和oh-package.json、oh-package-lock.json5中的@mcui/mccharts。
        //         </li>
        //         <li>
        //             2、打开项目终端。
        //         </li>
        //         <li>
        //             3、输入ohpm install @mcui/mccharts@2.0.9-rc.4
        //         </li>
        //         <li>
        //             4、重启编译器，运行项目查看是否正常，如有问题请及时反馈
        //         </li>
        //     </ul>
        //     <h5>如果遇到问题可将问题填写到下面收集表中</h5>
        //     <p>【腾讯文档】莓创图表2.0.9-rc.4内测问题收集 https://docs.qq.com/sheet/DYlZYcW5uYWpvTVFa</p>
        // </div>
    )
}

function App() {
    const [searchList, setSearchList] = useState(commonMenus)
    const [isSearchList, setIsSearch] = useState(false)
    // const [current, setCurrent] = useState('mail');

    // const history = useNavigate()

    const jump = function (e, path) {

        // 页面跳转方法
        // history({pathname: '/' + path})
        e.stopPropagation()
        window.location.href = '/' + path
    }

    // 输入框值发生改变时
    const searchChange = function (e) {
        const value = e.target.value
        const searchList = []
        commonMenus.forEach(item => {
            if (item.children) {
                const children = []
                item.children.forEach(cli => {
                    if (cli.label.indexOf(value) !== -1) {
                        children.push(cli)
                    }
                })
                if (children.length) {
                    searchList.push({
                        ...item,
                        children
                    })
                }
            }
        })
        setSearchList(searchList)
        setTimeout(() => {
            setSearchStyle()
        }, 10)
    }

    const searchFocus = function (e) {
        e.stopPropagation()
        setIsSearch(true)
        setSearchStyle()
        document.addEventListener('click', searchBlur)
    }
    const searchBlur = function () {
        setIsSearch(false)
        const searchBox = document.querySelector('#searchBox')
        searchBox.style.height = '0px'
        document.removeEventListener('click', searchBlur)
    }

    const openNotification = () => {
        if (isTips) return
        isTips = true
        notification.success({
            message: `版本更新`,
            description: <Tip version={version}/>,
            placement: 'bottomLeft',
            onClose: () => {
                localStorage.setItem('version', version)
            }
        });
    };

    openNotification()


    return (
        <div className={styles.home}>
            <header className={styles.navbar}>
                <div className={styles.logo}>
                    <a href="/"  rel="noopener noreferrer">
                        Mc Charts
                    </a>
                </div>
                <div className={styles.menus}>
                    <HeadMenu></HeadMenu>
                </div>
                <div className={styles.tools}>
                    <div className={styles.icons}>
                        <div className={styles.version}>v{version}</div>
                        <div className={styles.help}>
                            <a rel="noopener noreferrer" href="/faq" target="_blank">
                                快速搜集问题
                            </a>
                        </div>
                        <div className={styles.icon}>
                            <a rel="noopener noreferrer" href="https://gitee.com/cyaofeng_admin/mc-charts" target="_blank">
                                <GitlabOutlined />
                            </a>
                        </div>
                        {/*<div className={styles.icon}>*/}
                        {/*    <a  rel="noopener noreferrer" href="https://ant.design" target="_blank">*/}
                        {/*        <TwitterOutlined />*/}
                        {/*    </a>*/}
                        {/*</div>*/}
                    </div>
                    <div className={[styles.search, isSearchList ? styles.showSearch : ''].join(' ')} onClick={(e) => {e.stopPropagation()}}>
                        <input placeholder="McCharts Search" onChange={searchChange} onFocus={searchFocus}/>
                        <SearchOutlined />
                        <div  id="searchBox" className={styles.searchList}>
                            <ul id="searchList">
                                {
                                    searchList.map((item, index) => {
                                        return (
                                            <ul key={item.label}>
                                                <div className={styles.title}>{item.label}<RightOutlined /></div>
                                                {
                                                    item.children.map(cli => {
                                                        return (
                                                            <li key={cli.label} onClick={(e) => {jump(e, cli.key)}}>
                                                                {cli.label}
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </header>
            <div className={styles.view}>
                <RouterProvider router={router}/>
            </div>
        </div>
    )
}

export default App;
